<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Gantt Chart View</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="input-group mb-3">
                <div class="form-group col-3">
                    <label for="module">Module</label>
                    <!-- <input type="text" class="form-control" v-model="mm.module" id="module" aria-describedby="module"> -->
                    <select type = "dropdown" @change="checkModule" class="form-control" id="module" v-model="gcv.module">
                        <option v-for="(list, index) in this.moduleLists" :key="index" :value="list.value">{{ list.title }}</option>
                    </select>
                </div>
                <div class="form-group col-5">
                    <label for="subject">Customer Complaint/NCR</label>
                    <input type="text" v-if="this.gcv.module === ''" class="form-control" id="complaint-no" placeholder="Please Choose Module" disabled>
                    <app-lookup-field v-if="this.gcv.module === 'customercomplaint'" :model="gcv" :element="ccLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
                    <app-lookup-field v-if="this.gcv.module === 'ncr'" :model="gcv" :element="ncrLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
                    <app-lookup-field v-if="this.gcv.module === 'recall'" :model="gcv" :element="recallLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <app-gantt v-if="gcv.ganttChartData" :tasks="gcv.ganttChartData"></app-gantt>
                <!-- <app-gantt v-if="tasks" :tasks="tasks"></app-gantt> -->
            </div>
        </div>
        <br/><br/>
        <div class="row">
            <div class="form-group col-12">
                <label v-if="this.gcv.customerComplaintId || this.gcv.ncrId || this.gcv.recallId" for="log-table">Log Table</label>
                <app-log-history :ref="`logHistory${ this.gcv.customerComplaintId || '' }`" v-if="this.gcv.module === 'customercomplaint' && this.gcv.customerComplaintId" :id="this.gcv.customerComplaintId" :module="'cc'" />
                <app-log-history :ref="`logHistory${ this.gcv.recallId || '' }`" v-if="this.gcv.module === 'recall' && this.gcv.recallId" :id="this.gcv.recallId" :module="'recall'" />
                <app-log-history :ref="`logHistory${ this.gcv.ncrId || '' }`" v-if="this.gcv.module === 'ncr' && this.gcv.ncrId" :id="this.gcv.ncrId" :module="'ncr'" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import AppDatatable from '../../components/AppDatatable.vue'
import { ganttChartView, ganttChartData } from '../../models/ganttChartView'
import AppGantt from '../../components/AppGantt.vue';
import AppLogHistory from '../../components/AppLogHistory'
// import AppDataPagination from '../components/AppDataPagination.vue'
// import AppGoogleMaps from '../components/AppGoogleMaps.vue'
import AppLookupField from '../../components/AppLookupField.vue'
import AppNavBar from '../../components/AppNavbar.vue'
// import AppGooglePlaceAutocomplete from '../components/AppGooglePlaceAutocomplete.vue'
import api from '../../services/api'
import moment from 'moment'

export default {
  components: {
    AppDatatable, AppNavBar, AppGantt, AppLookupField, AppLogHistory
  },
  data() {
    return {
      gcv: {...ganttChartView, ganttChartData:[]},
      mode: 'day',
      number: '',
      logModule: '',
      tasks: [
            {
                name: 'Complaint Received',
                start: '2020-08-01',
                end: '2020-08-02',
                custom_class: 'bar-milestone'
            },
            {
                name: 'Distributed to internal UOI',
                start: '2020-08-05',
                end: '2020-08-05',
                custom_class: 'bar-milestone'
            },
            {
                name: 'CCF Log',
                start: '2020-08-11',
                end: '2020-08-13'
            },
            {
                name: 'Quality team doing investigation',
                start: '',
                end: ''
            },
      ],
      moduleLists: [
            {
                title: 'Customer Complaint',
                value: 'customercomplaint'
            },
            {
                title: 'NCR',
                value: 'ncr'
            },
            {
                title: 'Recall',
                value: 'recall'
            },
      ],
      ccLookup: {
            id: 'cc-list',
            title: 'Customer Complaint List',
            type: 'form',
            apiUrl: 'gantt-chart-cc',
            filter: ['complaintNo'],
            fields: [
                {
                    placeholder: 'Complaint No',
                    width: 12,
                    column: 'complaintNo'
                }
            ],
            dtElements: [
                {
                    title: 'Complaint No',
                    column: 'complaintNo'
                },
            ],
            affectedField: [
                {
                    from: 'customerComplaintId',
                    to: 'customerComplaintId'
                },
                {
                    from: 'complaintNo',
                    to: 'complaintNo'
                },
            ]
      },
      ncrLookup: {
            id: 'ncr-list',
            title: 'NCR List',
            type: 'form',
            apiUrl: 'recall-ncr-list',
            filter: ['ncrNo'],
            fields: [
                {
                    placeholder: 'NCR No',
                    width: 12,
                    column: 'ncrNo'
                }
            ],
            dtElements: [
                {
                    title: 'NCR No',
                    column: 'ncrNo'
                },
            ],
            affectedField: [
                {
                    from: 'ncrId',
                    to: 'ncrId'
                },
                {
                    from: 'ncrNo',
                    to: 'ncrNo'
                },
            ]
      },
      recallLookup: {
            id: 'recall-list',
            title: 'Recall List',
            type: 'form',
            apiUrl: 'gantt-chart-recall',
            filter: ['recallNo'],
            fields: [
                {
                    placeholder: 'Recall No',
                    width: 12,
                    column: 'recallNo'
                }
            ],
            dtElements: [
                {
                    title: 'Recall No',
                    column: 'recallNo'
                },
            ],
            affectedField: [
                {
                    from: 'recallId',
                    to: 'recallId'
                },
                {
                    from: 'recallNo',
                    to: 'recallNo'
                },
            ]
      },
    }
  },
  methods: {
    search() {
      this.filterData()
    },
    checkModule() {
        if (this.gcv.module === 'customercomplaint') {
            console.log('hapus NCR dan recall')
            this.gcv.customerComplaintId = ''
            this.gcv.complaintNo = ''
            this.gcv.recallId = ''
            this.gcv.recallNo = ''
        } else if(this.gcv.module === 'ncr') {
            console.log('hapus CC dan recall')
            this.gcv.ncrId = ''
            this.gcv.ncrNo = ''
            this.gcv.recallId = ''
            this.gcv.recallNo = ''
        } else if(this.gcv.module === 'recall') {
            console.log('hapus CC dan NCR')
            this.gcv.customerComplaintId = ''
            this.gcv.complaintNo = ''
            this.gcv.ncrId = ''
            this.gcv.ncrNo = ''
        }
    },
    async finishLookup(data) {
        const currentgcv = this.gcv
        this.gcv = {
            ...currentgcv,
            ...data
        }

        if (this.gcv.module === 'customercomplaint') {
            this.number = this.gcv.customerComplaintId
            this.logModule = 'cc'
        } else if(this.gcv.module === 'ncr') {
            this.number = this.gcv.ncrId
            this.logModule = 'ncr'
        } else if(this.gcv.module === 'recall') {
            this.number = this.gcv.recallId
            this.logModule = 'recall'
        }

        const query = {
            params: {
                module: this.gcv.module,
                number: this.number,
            }
        }

        const queryHistory = {
            params: {
                id: this.number,
                module: this.logModule,
            }
        }
        this.gcv.ganttChartData = []
        const cccApi = api('get-gantt-chart')
        this.gcv.ganttChartData = await cccApi.getWithQuery(query)

        this.$refs[`logHistory${ this.number || '' }`].loadHistoryData(queryHistory)
    },
  }
  // selectRow(id) {
  //   this.selectedId = id
  // },    
}
</script>